export const monthsList = [
  'ינואר',
  'פברואר',
  'מרץ',
  'אפריל',
  'מאי',
  'יוני',
  'יולי',
  'אוגוסט',
  'ספטמבר',
  'אוקטובר',
  'נובמבר',
  'דצמבר',
];

export const numberToMonthText = (month: number) => {
  return monthsList[month - 1];
};

export const monthTextToNumber = (month: string) => {
  const monthIndex = monthsList.indexOf(month);
  return monthIndex + 1;
};
